import React from "react";
import Page from "./Page";

const PageWithState = (props) => <Page {...props} />;

export default PageWithState;
